import { tabbable } from 'tabbable';
import { MIDROLL, PREROLL } from '../../../ad/types';
import { UI_IS_INTERACTING } from '../../../store/types';

export const handleFocusOnAdRolls = ({ player, isAd, adType, keyCode, isInteracting }) => {
  if (!isAd || ![PREROLL, MIDROLL].includes(adType) || ![37, 39].includes(keyCode)) {
    return;
  }
  const ui = document.querySelector('.magneto-wrapper');
  if (!ui) return;

  const tabbableElements = tabbable(ui);
  if (!tabbableElements.length) return;

  player.store.dispatch({
    type: UI_IS_INTERACTING,
    payload: { isInteracting }
  });

  let currentIndex = tabbableElements.findIndex((el) => el === document.activeElement);
  currentIndex = currentIndex >= 0 ? currentIndex : 0;

  // Backward
  if (keyCode === 37) {
    const previousIndex = currentIndex - 1;
    const finalPreviousIndex = previousIndex >= 0 ? previousIndex : tabbableElements.length - 1;
    tabbableElements[finalPreviousIndex].focus();
    return;
  }

  // Forward
  if (keyCode === 39) {
    const nextIndex = currentIndex + 1;
    const finalNextIndex = nextIndex < tabbableElements.length ? nextIndex : 0;
    tabbableElements[finalNextIndex].focus();
  }
};
